import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@assets/css/common.scss";
import Element from "element-ui";
import VueQuillEditor from "vue-quill-editor";
// require styles
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

Vue.use(Element);
Vue.config.productionTip = false;
Vue.use(VueQuillEditor /* { default global options } */);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js